export const HourlyRate: number = 10;
